import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.79302 9.04283C3.40249 9.43336 3.40249 10.0665 3.79302 10.457C4.18354 10.8476 4.81671 10.8476 5.20723 10.457L8.00006 7.66421L10.7929 10.457C11.1834 10.8476 11.8166 10.8476 12.2071 10.457C12.5976 10.0665 12.5976 9.43336 12.2071 9.04283L8.70717 5.54289C8.31664 5.15237 7.68348 5.15237 7.29296 5.54289L3.79302 9.04283Z"
        fill="#101010"
      />
    </svg>
  );
};

export default Svg;
